import React from 'react';
import styled from 'styled-components'
import ModalContent from './ModalContent'
import { CSSTransition } from 'react-transition-group';
import { getLocaleWordContent } from '../../../utils/language.util';
import { toClassName } from '../../../utils/style.util';
import { Link } from 'react-router-dom';

const Modal = styled.div`
transition-duration: 0.5s; text-align: initial; z-index:9998;
    .modal { 
        &, &-mask { width: 100%; height: 100%; position: fixed; top: 0; left: 0; }
        &-mask {  background-color: rgba(0, 0, 0, .5);z-index: 9998; }
        &-area { box-sizing:border-box; z-index: 9998; 
        position: fixed; left:50%; top:50%; transform:translate(-50%, -50%);       
        /* position: absolute;
        left: 0 !important; margin-left: auto !important; right: 0 !important; margin-right: auto !important;
        top: 0 !important; margin-top: auto !important; bottom: 0 !important; margin-bottom: auto !important;  */
        }
        &-close-button {position: absolute; top:-32px; right:0; }
        &-header { font-size: 20px; font-weight: normal; }
        &-body { /* display: flex; flex-direction: column; */ 
            max-height: 500px; overflow-y: auto; 
            ::-webkit-scrollbar {width: 5px; height: 5px; position: absolute;}
            ::-webkit-scrollbar-button:start:decrement, 
            ::-webkit-scrollbar-button:end:increment {display: block; width: 0;height: 0; background: url() rgba(0,0,0,.05);}
            ::-webkit-scrollbar-track {  background: rgba(0,0,0,.07); border-radius: 15px;}
            ::-webkit-scrollbar-thumb {  background: rgba(0,0,0,.1);  border-radius: 15px;}
        }
    }
    .notModalBtn { cursor: pointer; font-size: 14px; font-weight: bold;}
    .notModalBtn:hover { color:#ff432f}
    .modal-close-button{width:20px;height:20px;}
    .modal-area{background:white;padding:30px;}

`;

const ModalMask = ({ id, status, onCloseModal }) => {
    return (
        <CSSTransition in={status === id} classNames="fade" timeout={500} unmountOnExit>
            <div className="modal-mask" onClick={onCloseModal}></div>
        </CSSTransition>
    )
}

const ModalArea = ({ id, status, areaClass, width, children, onCloseModal, timeLimit, onLimitModal }) => {
    return (
        <CSSTransition in={status === id} classNames="fade" timeout={500} unmountOnExit>
            <section className={toClassName(['modal-area', areaClass])} style={{ width: width }}>
                {/* <button className="modal-close-button" onClick={onCloseModal}/> */}
                {/* <button className="modal-close-button" onClick={onCloseModal}>x</button> */}

                <input type="image" src={require('../../../resources/assets/images/ic_close.png')} className="modal-close-button" onClick={onCloseModal} alt="close"/>
                {/* <input type="image" className="modal-close-button" onClick={onCloseModal} alt="close" /> */}
                {children}
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                {timeLimit && <div className="notModalBtn" onClick={() => onLimitModal(id)} >{getLocaleWordContent('limitModal')}</div>}
                <div className="detail"><Link to='/notice'><button className="btn btn-warning">{getLocaleWordContent('Detail')}</button></Link></div>
                </div>

            </section>
        </CSSTransition>
    )
}

const ModalWrapper = ({ id, status, timeLimit, areaClass, width, title, body, footer, onShowModal, onLimitModal, children }) => {
    console.log("ModalWrapper status", status);
    return (
        <Modal className="modal-wrapper">
            <ModalMask id={id} status={status} onCloseModal={() => onShowModal(0)} />
            <ModalArea id={id} areaClass={areaClass} status={status} onCloseModal={() => onShowModal(0)} width={width} timeLimit={timeLimit} onLimitModal={onLimitModal} >
                <ModalContent title={title} body={body} footer={footer} onCloseModal={() => onShowModal(0)} children={children} />
            </ModalArea>
        </Modal>
    )
}

export default function ModalPresenter({ id, timeLimit, onLimitModalCheck, ...rest }) {

    // return (
    //         <ModalWrapper areaClass={'home_page'} timeLimit={timeLimit} {...rest} />
    // );
    return (
        !timeLimit 
            ? <ModalWrapper areaClass={'home_page'} timeLimit={timeLimit} {...rest} />
            : timeLimit && onLimitModalCheck(id) && <ModalWrapper id={id} areaClass={'home_page'} timeLimit={timeLimit} {...rest} />
    )
}


